module.exports = __webpack_public_path__ + "static/matiaswork2-6ffbad8690ff9a8339bb09b8290a01bd.jpg";